// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"83":"90b3fe61","1134":"42d1df52","6136":"d56c6833"}[chunkId] + ".css";
};